module.exports = __webpack_public_path__ + "img/button-promote.ea106c65.png";